import { useState } from "react";
import {
  Typography,
  Stack,
} from "@mui/material";
import VerificationInput from "react-verification-input";
import { useNavigate } from "react-router-dom";

import { CustomButton } from "../../components";
import i18n from "../../i18n-config";
import theme from "../../theme/theme";
// import { useDispatch } from "react-redux";

import SigninTextInput from "../../components/SigninTextInput";
import { capitalizeFirstLetter } from "../../utils/strings";
import { ForgotICON, LockICON, NewMdpICON, OtpICON } from "../../assets/icons";

const ForgotPassword = () => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");
  const [currentTab, setCurrentTab] = useState(2);
  // const [codeValue, setCodeValue] = useState("");

  // const [isLoading, setIsLoading] = useState(false);

  // const callback = () => {
  //   setIsLoading(false);
  //   navigate("/");
  // };

  const onChangeUsername = (value: string) => {
    setUsername(value);
  };

  // const onChangePassword = (value: string) => {
  //   setPassword(value);
  // };

  const onSubmit = async (event: any) => {
    try {
      event.preventDefault();

      // const user = users.filter(
      //   (user) =>
      //     user.username?.toLowerCase() === username.toLowerCase() &&
      //     user?.password === password
      // );
      // setIsLoading(true);

      // if (user.length) {
      //   dispatch(createUser(user[0]));
      //   navigate("/sale");
      // } else {
      //   showError(
      //     capitalizeFirstLetter(i18n.t("incorrect_username_or_password")),
      //     {
      //       horizontal: "right",
      //       vertical: "bottom",
      //     }
      //   );
      // }

      // setIsLoading(false);
    } catch (error) {
      // showError(capitalizeFirstLetter(i18n.t("error_occured")), {
      //   horizontal: "right",
      //   vertical: "bottom",
      // });
      // setIsLoading(false);
      // dispatch(authIsLoaded(false));
      console.log(error);
    }
  };

  const disabled = !username?.trim()

  return (
    <Stack justifyContent={"center"} alignItems="center">
      {currentTab === 1 ? (
        <Stack mt={10} alignItems="center" sx={{ width: 400 }}>
          <Typography fontWeight={"550"} fontSize={24} mb={4}>
            {i18n.t("motdepasse_reinitialiser")}
          </Typography>
          <ForgotICON />
          <Typography my={4}>
            {i18n.t("motdepasse_reinitialiser_desc")}
          </Typography>
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("votre_email"))}
            value={username}
            onChange={onChangeUsername}
          />

          <CustomButton
            title={capitalizeFirstLetter(i18n.t("recevoir_code"))}
            titleStyle={{ color: "white", fontSize: 14, padding: 1 }}
            rootStyle={{ width: "100%", marginTop: 2 }}
            onClick={onSubmit}
            disabled={disabled}
          />

          <CustomButton
            title={capitalizeFirstLetter(i18n.t("revenir_connexion"))}
            titleStyle={{
              color: "#9BA69C",
              marginLeft: 1,
              fontSize: 13,
            }}
            rootStyle={{
              backgroundColor: "transparent",
              width: "100%",
              marginTop: 8,
            }}
            onClick={() => navigate("/signin")}
          />
        </Stack>
      ) : null}

      {currentTab === 2 ? (
        <Stack mt={10} alignItems="center" sx={{ width: 400 }}>
          <Typography fontWeight={"550"} fontSize={24} mb={4}>
            {i18n.t("verification_otp")}
          </Typography>
          <OtpICON />
          <Stack direction={"row"} mt={4}>
            <Typography fontSize={14}>
              {i18n.t("verification_email")}
            </Typography>
            <Typography fontSize={14} ml={1} color={theme.colors.primary}>
              contact@gmail.com
            </Typography>
          </Stack>

          <Stack direction={"row"} mt={1} mb={4}>
            <Typography fontSize={14} color={"#9BA69C"}>
              {i18n.t("verification_changer")}
            </Typography>
            <Typography fontSize={14} ml={1} color={theme.colors.primary}>
              {i18n.t("changer")}
            </Typography>
          </Stack>

          <VerificationInput
                placeholder=""
                validChars="0-4"
                length={4}
                // onChange={(val) => setCodeValue(val)}
                classNames={{
                  container: "character-container",
                  character: "character",
                  characterInactive: "character--inactive",
                  characterSelected: "character--selected",
                }}
              />       

          <Typography fontSize={14} color={"#9BA69C"} mt={4}>
              {i18n.t("verification_spam")}
            </Typography>

          <CustomButton
            title={capitalizeFirstLetter(i18n.t("valider"))}
            titleStyle={{ color: "white", fontSize: 14, padding: 1 }}
            rootStyle={{ width: "100%", marginTop: 2 }}
            onClick={onSubmit}
            disabled={disabled}
          />

          <CustomButton
            title={capitalizeFirstLetter(i18n.t("revenir_connexion"))}
            titleStyle={{
              color: "#9BA69C",
              marginLeft: 1,
              fontSize: 13,
            }}
            rootStyle={{
              backgroundColor: "transparent",
              width: "100%",
              marginTop: 8,
            }}
            onClick={() => navigate("/signin")}
          />
        </Stack>
      ) : null}

      {currentTab === 3 ? (
        <Stack mt={10} alignItems="center" sx={{ width: 400 }}>
          <Typography fontWeight={"550"} fontSize={24} mb={4}>
            {i18n.t("nouveau_motdepasse")}
          </Typography>
          <NewMdpICON />
          <Typography my={4}>{i18n.t("nouveau_motdepasse_desc")}</Typography>
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("motdepasse"))}
            value={username}
            type="password"
            endIcon={<LockICON />}
            onChange={onChangeUsername}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("confirmer"))}
            value={username}
            type="password"
            onChange={onChangeUsername}
          />

          <CustomButton
            title={capitalizeFirstLetter(
              i18n.t("motdepasse_reinitialiser_alt")
            )}
            titleStyle={{ color: "white", fontSize: 14, padding: 1 }}
            rootStyle={{ width: "100%", marginTop: 2 }}
            onClick={onSubmit}
            disabled={disabled}
          />

          <CustomButton
            title={capitalizeFirstLetter(i18n.t("revenir_connexion"))}
            titleStyle={{
              color: "#9BA69C",
              marginLeft: 1,
              fontSize: 13,
            }}
            rootStyle={{
              backgroundColor: "transparent",
              width: "100%",
              marginTop: 8,
            }}
            onClick={() => navigate("/signin")}
          />
        </Stack>
      ) : null}
    </Stack>
  );
};

export default ForgotPassword;
